import { POPOVER_BOTTOM_START } from "designSystem/styles/popover-positions";
import { Box, Button, Popover } from "designSystem/index";
import React, { MouseEventHandler } from "react";

export default () => {
	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick: MouseEventHandler = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = !!anchorEl;
	return (
		<Box textAlign="left">
			<Button design="primary" onClick={handleClick}>
				Open Popover
      		</Button>
			<Popover
				anchorEl={anchorEl}
				onClose={handleClose}
				open={open}
				{...POPOVER_BOTTOM_START}
			>
				<Box px={3}>
					<p>The content of the Popover. Might be any HTML elements here.</p>
					<Button design="primary" onClick={handleClose}>
						Some Button
					</Button>
					<p>Click outside of popover to close, or click "Open Popover" button to toggle</p>
				</Box>
			</Popover>
		</Box>
	);
};

